import { isNil } from "./identity";

/**
 * @param put a function that will be called if map doesn't contain a value for key
 * @returns the value stored in map at key, if it exists, or the result of put(key)
 * which will also be stored in the map
 **/
export const getOrPut = <K, V>(
  map: Map<K, V>,
  key: K,
  put: (key: K) => V
): V => {
  const existing = map.get(key);
  if (!isNil(existing)) {
    return existing;
  }
  const created = put(key);
  map.set(key, created);
  return created;
};
